<div class="mon-chart">
    <canvas [height]="height"
            class="chart-horizontal-bar"
            chartBase
            [chartType]="'horizontalBar'"
            [chartData]="data"
            [chartLabels]="labels"
            [chartSeries]="series"
            [chartOptions]="options"
            [chartDatasetOverride]="override"
            [chartColors]="colors">
    </canvas>
</div>
